module.exports = require("./ar-SO.d.ts");